<form [formGroup]="phoneForm">
  <!-- TODO: MINIMO PARA FUNCIONAR O TELEFONE, quando for implementar o restante para outros types de input, precisa fazer uma regra para formar um switch case para os types de input -->
  <label [class.label-error]="isValidFields && origin() === 'SHELL'">
    @if (label()) {
    {{label()}}
    }
    @if (isValidFields && origin() === 'SHELL') {
    <span class="required-field">({{ 'my-account.my-data.mandatory' | translate }})</span>
    }
    @if (!isValidFields) {
    <img src="../../../../../../assets/images/icons/Icon_Checkmark.svg" alt="icon_checkmark" />
    }
  </label>

  <!-- fazer o disabled  -->
  <div class="d-flex g20">
    <input type="tel" class="column-1" id="cityCode" name="cityCode" formControlName="cityCode"
      mask="{{maskCityCode}}" [ngClass]="{'error-input': isValidFields}" />
    <input type="tel" class="column-2" id="phoneNumber" name="phoneNumber" formControlName="phoneNumber"
      mask="{{maskPhone}}" [ngClass]="{'error-input': isValidFields}" />
  </div>

  @if (legend()) {
  <small [class.label-error]="isValidFields && origin() === 'SHELL'">{{legend()}}</small><br>
  }

  @if (isValidFields && origin() !== 'SHELL') {
  <span class="required-field">{{ this.error | translate }}</span>
  }
</form>
